var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.menus.length > 0
    ? _c(
        "div",
        [
          _vm.$screen.width >= 992
            ? _c(
                "b-dropdown",
                {
                  attrs: {
                    variant: "outline-secondary",
                    size: "sm",
                    text: _vm.selectedMenu.text,
                    right: "",
                  },
                },
                [
                  _c(
                    "b-dropdown-header",
                    { attrs: { id: "dropdown-header-label" } },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(this.FormMSG(1, "Switch to another section")) +
                          "\n\t\t"
                      ),
                    ]
                  ),
                  _vm._l(_vm.menus, function (menu) {
                    return _c(
                      "b-dropdown-item-button",
                      {
                        key: menu.value,
                        attrs: {
                          active: _vm.selectedMenu.value === menu.value,
                          action: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMenu(menu)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t" + _vm._s(menu.text) + "\n\t\t")]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.$screen.width < 992
            ? _c(
                "b-dropdown",
                {
                  attrs: {
                    variant: "link",
                    "toggle-class": "text-decoration-none",
                    "no-caret": "",
                    right: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button-content",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                staticClass: "mx-0",
                                attrs: { variant: "primary", size: "sm" },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-bars",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1724340326
                  ),
                },
                [
                  _c(
                    "b-dropdown-header",
                    { attrs: { id: "dropdown-header-label" } },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(this.FormMSG(1, "Switch to another section")) +
                          "\n\t\t"
                      ),
                    ]
                  ),
                  _vm._l(_vm.menus, function (menu) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: menu.value,
                        attrs: {
                          active: _vm.selectedMenu.value === menu.value,
                          action: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMenu(menu)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t" + _vm._s(menu.text) + "\n\t\t")]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }